import { productCard } from '../../components/product-card'
import { registerElement } from '../../utils/desing-system'

import './search-results.scss'

registerElement(productCard)
